import { render, staticRenderFns } from "./TapSortingStatement.vue?vue&type=template&id=be943350&"
import script from "./TapSortingStatement.vue?vue&type=script&lang=ts&"
export * from "./TapSortingStatement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports